import styled from "styled-components";

export const Container = styled.div.attrs({})`
  background-color: #fbf8fc;
  width: 50%;
  min-height: 30rem;
  border-radius: 5px;
  padding: 3rem 4rem 3rem 4rem;

  @media screen and (max-width: 768px) {
    width: 95%;
    padding: 3rem 2rem 3rem 2rem;
  }
`;

export const Header = styled.div.attrs({
  className: "text-2xl font-bold flex-1 text-center",
})`
  color: var(--primaryPurpleMain);
`;
export const Label = styled.label.attrs({
  className: "text-medium font-semibold",
})`
  color: #0f0015;
`;
export const ISelect = styled.select.attrs({
  className: "rounded mt-1 focus:outline-none px-5 text-gray",
})`
  width: 100%;
  border: 1px solid #69606c;
  height: 2.5rem;
  background: inherit;
  color: grey;
`;

export const Input = styled.input.attrs({
  className: "rounded mt-1 focus:outline-none px-5 text-gray",
})<any>`
  width: ${(props: any) => (props.noBorder ? "initial" : "100%")};
  border: ${(props: any) =>
    props.noBorder ? "0" : "1px solid rgba(58, 53, 65, 0.23)"};
  height: 2.5rem;
  background: inherit;
  color: grey;
  position: relative;
  font-size: ${(props: any) => (props.noBorder ? "14px" : "initial")};
  left: ${(props: any) => (props.noBorder ? "-1.5rem" : "initial")};
  bottom: ${(props: any) => (props.noBorder ? ".5rem" : "initial")};
`;
export const Line = styled.div.attrs({ className: "mt-9 mb-3" })`
  border-top: 1px solid rgba(29, 28, 29, 0.13);
`;

export const Row = styled.div.attrs({})`
  display: grid;
  grid-template-columns: 70% 30%;

  @media screen and (max-width: 768px) {
    grid-template-columns: 60% 40%;
  }
`;
export const LogIncidentBtnsContainer = styled.div`
  margin: 14px 0;
  display: flex;
  justify-content: flex-end;
  @media screen and (max-width: 425px) {
    justify-content: space-between;
  }
`;
// styles for the buttons
// button interface
// styles for general button
// py-2 px-10

export const BackBtn = styled.button.attrs({
  className: "rounded cursor-pointer text-sm",
})`
  background-color: white;
  color: var(--main-purple-light);
  border: 1px solid var(--main-purple-light);
  width: 25%;
  @media screen and (max-width: 768px) {
    width: 40%;
  }
  @media screen and (max-width: 425px) {
    width: 100%;
  }
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const NextBtn = styled.button.attrs({
  className: "rounded  text-sm  py-2 px-10",
})`
  cursor: pointer;
  background-color: var(--primaryPurpleMain);
  color: ${(props: any) =>
    props.cancel ? "var(--primaryPurpleMain)" : "white"};
  background-color: ${(props: any) =>
    props.cancel ? "white" : "var(--primaryPurpleMain)"};
  border: none;
  width: 20%;
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const CancelBtn = styled.button.attrs({
  className: "rounded cursor-pointer text-sm py-2 px-10",
})`
  background-color: white;
  color: var(--primaryPurpleMain);
  border: 1px solid var(--primaryPurpleMain);
  width: 20%;
`;

export const SubHeading = styled.span.attrs({
  className: "text-sm font-bold",
})`
  color: var(--main-purple-light);
`;

export const ComfirmText = styled.span.attrs({
  className: "text-sm font-medium ml-1",
})`
  color: var(--purple300);
`;
export const SelectContainer = styled.div.attrs({})`
  position: relative;
`;
export const LoadingIcon = styled.div.attrs({})`
  position: absolute;
  right: 43px;
  top: 26px;
`;
